import styled from "styled-components";
import { colors } from "../../../../../theme/theme";

export const ContentHeader = styled.div`
    color: ${colors.greyscale.darker_grey};
    font-size: 16px;
    border-bottom: 1px solid  ${colors.greyscale.light_grey};

    .title{
        font-size: 26px;
    }

    .subtitle{
        font-size: 14px;
        padding-left: 15px;
    }
`

export const ContentBody = styled.div`
    color: ${colors.greyscale.darker_grey};
    font-size: 16px;
`

export const CardButton = styled.div`    
    button { 
        width: 100%;
        padding: 7px;
        border-radius: 16px;
        background-color: transparent;
        border-radius: 4px;
        border: 1px solid ${colors.mainColors.verde_dstore};
        color: ${colors.mainColors.verde_dstore};
    }
`;

export const MultiSelectFilter = styled.div`
    .multiselect-dropdown{
        width: 100%;
        max-height: 40px;
        font-size: 14px;
    }

    .p-multiselect .p-multiselect-label.p-placeholder{
        color: ${colors.greyscale.grey2};
    }
`;

